/**
 * Öppnar den gemensamma förslagspanelen (BL-169) från valfri ingång.
 * Panelen (ForslagPanel) är monterad en gång i Layout och lyssnar på händelsen.
 *
 * @param {{ kalla?: 'sidfot'|'fab'|'pa_gang', typ?: string, modul?: string, rubrik?: string,
 *           vy?: 'mina', arende?: string }} [forval]  vy 'mina' öppnar Mina ärenden (BL-377)
 */
export const OPPNA_FORSLAG = 'kp-oppna-forslag';
/** Äldre händelse från /rapportera, finns kvar så att gamla länkar fungerar. */
export const OPPNA_FORSLAG_GAMMAL = 'open-feedback-fab';

export default function oppnaForslag(forval = {}) {
  window.dispatchEvent(new CustomEvent(OPPNA_FORSLAG, { detail: forval }));
}
